import styled from "styled-components"
import { trainRemove, trainAppear } from "../../../animations/Transitions"

interface Train_Style_Props {
  id?: any
  anim?: boolean
  color?: string
  firstAnim?: boolean
}

export const TrainWrapper = styled.div`
  position: absolute;
  top: -32px;
  transform: translateX(50%);
  /* width: 100%; */
  right: 50%;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  /* opacity: 1; */
`

export const TrainComponent = styled.div<Train_Style_Props>`
  width: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.167s linear;
  /* opacity: 1; */
  position: relative;
  margin-right: 2px;
  :first-child {
    /* z-index: -1; */
    ${({ anim }) => anim && trainRemove}
  }
  :last-child {
    /* z-index: -1; */
    /* opacity: 1; */
    ${({ firstAnim }) => firstAnim && trainAppear}
  }
`
export const TrainElement = styled.p<Train_Style_Props>`
  font-size: 9px;
  border-radius: 30px;
  color: ${({ color }) => color || "#ffb000"};
  border: 2px solid ${({ color }) => color || "#ffb000"};
  padding: 5px 2px;
  min-width: 53px;
  display: flex;
  text-align: center;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
`
